import { PublicFeatureFlagsQuery } from '@water-web/api';

export const PublicFeatureFlagsConstructor = (apiUrl: string) => ({
  get: new PublicFeatureFlagsQuery(apiUrl),
});
